import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { environment } from './../../environments/environment';
import { AuthGuard } from './guards/auth-guard/auth.guard';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServiceAppService {
  public baseUrlservice: string

  private auth: AuthGuard;

  constructor(private httpClient: HttpClient, private router: Router) {
    this.baseUrlservice = environment.URL_API;
    this.auth = new AuthGuard(this.router);
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: JSON.parse(sessionStorage.getItem('currentUser')).token
    })
  };

  /* RETORNAR DADOS API */

  public postLogin(url: any) {
    const httpOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.httpClient.post<any>(this.baseUrlservice + url, null, httpOption);
  }

  public getToken(url: any) {
    const httpOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.httpClient.get<any>(this.baseUrlservice + url, httpOption);
  }


  public getDados(url: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: JSON.parse(sessionStorage.getItem('currentUser')).token
      })
    }
    return this.httpClient.get<any>(this.baseUrlservice + url, httpOptions);
  }

  public downloadArquivo(url: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: JSON.parse(sessionStorage.getItem('currentUser')).token
      })
    };

    return this.httpClient.get<any[]>(this.baseUrlservice + url, httpOptions);
  }


  public postDados(url: any, body: any) {
    return this.httpClient.post<any>(this.baseUrlservice + url, body, this.httpOptions);
  }

  public postDadosTexto(url: any, body: any) {
    return this.httpClient.post(this.baseUrlservice + url, body, {
      ...this.httpOptions,
      responseType: 'text'
    });
  }

  public getGeneric(url: string, page?: number, size?: number, filtroDescricao?: String, filtroTipoOS?: String) {
    let queryParams = new HttpParams();

    if (page !== undefined) {
      queryParams = queryParams.set('page', page.toString());
    }
    if (size !== undefined) {
      queryParams = queryParams.set('size', size.toString());
    }
    if (filtroDescricao !== null) {
      queryParams = queryParams.set('filtroDescricao', filtroDescricao.toString());
    }
    if (filtroTipoOS !== null) {
      queryParams = queryParams.set('filtroTipoOS', filtroTipoOS.toString());
    }
    return this.httpClient.get<any>(`${this.baseUrlservice}${url}`, { params: queryParams, ...this.httpOptions });
  }

  public buscarServico(url: string, page?: number, size?: number, dealerId?: number, processo?: String, status?: String) {
    let queryParams = new HttpParams();

    if (page !== undefined) {
      queryParams = queryParams.set('page', page.toString());
    }
    if (size !== undefined) {
      queryParams = queryParams.set('size', size.toString());
    }
    if (dealerId !== undefined) {
      queryParams = queryParams.set('dealerId', dealerId.toString());
    }
    if (processo !== undefined) {
      queryParams = queryParams.set('processo', processo.toString());
    }
    if (status !== undefined) {
      queryParams = queryParams.set('status', status.toString());
    }

    return this.httpClient.get<any>(`${this.baseUrlservice}${url}`, { params: queryParams, ...this.httpOptions });
  }

  deleteDados(url: any, bodyDado) {
    const optionDelete = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      body: bodyDado
    };
    return this.httpClient.delete<any>(this.baseUrlservice + url, optionDelete);
  }

  public exclusao(url: any) {
    return this.httpClient.delete<any>(this.baseUrlservice + url, this.httpOptions);
  }

  public putDados(url: any, body: any): Observable<any> {
    return this.httpClient.put<any>(this.baseUrlservice + url, body, this.httpOptions);
  }

  public putDadosTexto(url: any, body: any): Observable<string> {
    return this.httpClient.put(this.baseUrlservice + url, body, {
      ...this.httpOptions,
      responseType: 'text'
    });
  }

  /* IMPORTACAO ARQUIVO */

  public postArquivo(url: any, body: any) {
    const optionArquivo = { headers: new HttpHeaders({ 'Authorization': sessionStorage.getItem('token') }) };
    return this.httpClient.post<any>(this.baseUrlservice + url, body, optionArquivo)
      .pipe(
        catchError(error => {
          return throwError(error);
        })
      );
  }

  public postArquivoItem(url: any, body: any) {
    const optionArquivo = { headers: new HttpHeaders({ 'Authorization': sessionStorage.getItem('token') }) };
    return this.httpClient.post<any>(this.baseUrlservice + url, body, optionArquivo);
  }

  /* RETORNAR DADOS API - MOCK */

  public getPadrao(rota) {
    return this.httpClient.get<any>('assets/' + rota)
      .toPromise()
      .then(res => res)
  }

  getUserRole(): string {
    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    return currentUser && currentUser.username ? currentUser.username : 'Unknown User';
  }

  getImagem(path: string) {
    return this.httpClient.get<any>(`${environment.URL_API}${path}`);
  }

  public getURL(): Observable<any[]> {
    return this.httpClient.get<any[]>(environment.URL_API + '/ativacao_menu/listarRotas?idioma=1', this.httpOptions)
  }

  public verificarRotas(rota: string): Observable<any[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: JSON.parse(sessionStorage.getItem('currentUser')).token
      })
    }
    return this.httpClient.get<any[]>(environment.URL_API + `/ativacao_menu/verificarRotas?rota=${rota}`, httpOptions)
  }

  downloadExcelFile(url: any) {
    return this.httpClient.get(environment.URL_API + url,
      { responseType: 'blob', headers: this.httpOptions.headers });
  }

}
